<template>
    <svg
      :width="width"
      :height="height"
      viewBox="0 0 60 60"
      xmlns="http://www.w3.org/2000/svg"
      :class="backgroundColor"
    >
      <!-- 회색 원 배경 -->
      <path
        d="M30 2C45.464 2 58 14.536 58 30C58 45.464 45.464 58 30 58C14.536 58 2 45.464 2 30C2 14.536 14.536 2 30 2Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="4"
      />
  
      <!-- 느낌표 바디 -->
      <path
        d="M3.9994 0.692289C4.91746 0.692289 5.79791 1.02659 6.44708 1.62166C7.09624 2.21673 7.46094 3.02381 7.46094 3.86537L7.46094 22.9038C7.46094 23.7454 7.09624 24.5525 6.44708 25.1475C5.79791 25.7426 4.91746 26.0769 3.9994 26.0769C3.08134 26.0769 2.20088 25.7426 1.55172 25.1475C0.902552 24.5525 0.537858 23.7454 0.537858 22.9038L0.537859 3.86537C0.53786 3.02381 0.902554 2.21673 1.55172 1.62166C2.20088 1.02659 3.08134 0.692289 3.9994 0.692289Z"
        fill="#FFFFFF"
        transform="translate(26,12)"
      />
  
      <!-- 느낌표 점 -->
      <path
        d="M3.9994 28.3848C4.91746 28.3848 5.79791 28.7495 6.44708 29.3986C7.09624 30.0478 7.46094 30.9283 7.46094 31.8463C7.46094 32.7644 7.09624 33.6448 6.44708 34.294C5.79791 34.9432 4.91746 35.3079 3.9994 35.3079C3.08134 35.3079 2.20088 34.9432 1.55172 34.294C0.902556 33.6448 0.537862 32.7644 0.537862 31.8463C0.537862 30.9283 0.902556 30.0478 1.55172 29.3986C2.20088 28.7495 3.08134 28.3848 3.9994 28.3848Z"
        fill="#FFFFFF"
        transform="translate(26,12)"
      />
    </svg>
  </template>
  
  <script>
  export default {
    name: 'IconAlert',
    props: {
      width: {
        type: [String, Number],
        default: 60,
      },
      height: {
        type: [String, Number],
        default: 60,
      },
      backgroundColor: {
        type: String,
        default: 'text-background-basic-4', // Tailwind 색상 클래스
      },
    },
  }
  </script>